export function initPrograms() {
  const programButtons    = document.querySelectorAll('[data-program-index]');
  const programDetail     = document.querySelector('[data-program-detail]');
  const programBadge      = document.querySelector('[data-program-badge]');
  const programName       = document.querySelector('[data-program-name]');
  const programDescription = document.querySelector('[data-program-description]');
  const programDetailText = document.querySelector('[data-program-detail-text]');

  if (!programButtons.length) return;

  // On mobile the detail card is dropped: each program becomes a collapsible
  // accordion with its running text injected right below the header (see
  // _responsive.scss). The desktop single-detail panel is skipped entirely.
  if (window.matchMedia('(max-width: 680px)').matches) {
    programButtons.forEach((button, i) => {
      const panel = document.createElement('div');
      panel.className = 'program-accordion-panel';

      const description = document.createElement('p');
      description.textContent = button.dataset.description || '';

      const detail = document.createElement('p');
      detail.className = 'detail';
      detail.textContent = button.dataset.detail || '';

      panel.append(description, detail);
      button.insertAdjacentElement('afterend', panel);

      // First program stays open; CSS reacts to .is-open.
      button.classList.toggle('is-open', i === 0);
      button.addEventListener('click', () => button.classList.toggle('is-open'));
    });
    return;
  }

  const isOptional = (tag) => /opcion/i.test(tag || '');

  function switchProgram(button) {
    programButtons.forEach((btn) => btn.classList.remove('is-active'));
    button.classList.add('is-active');

    const optional = isOptional(button.dataset.tag);

    if (programDetail) {
      programDetail.classList.toggle('is-optional', optional);
      programDetail.classList.remove('is-switching');
      void programDetail.offsetWidth; // force reflow
      programDetail.classList.add('is-switching');
    }

    if (programBadge) {
      programBadge.textContent = `${button.dataset.tag} program`;
      programBadge.classList.toggle('is-optional', optional);
    }
    if (programName) programName.textContent = button.dataset.name || '';
    if (programDescription) programDescription.textContent = button.dataset.description || '';
    if (programDetailText) programDetailText.textContent = button.dataset.detail || '';
  }

  programButtons.forEach((button) => {
    button.addEventListener('click', () => switchProgram(button));
  });
}
